import HomeExplorer from "./HomeExplorer";

export default {
  HomeExplorer,
};
